import { useMemo } from 'react';

import { InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { useGetTreatmentModalitiesEnumQuery } from '~/store/services/enumerations';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassModalitiesField = ({
  value,
  onChange,
  leftIcon,
  isReadOnly,
  placeholder,
}: GroupClassBaseFieldProps<string[]>) => {
  const { data: modalitiesData } = useGetTreatmentModalitiesEnumQuery();

  const modalitiesOptions = useMemo(
    () =>
      modalitiesData?.map((modality) => ({
        label: modality.label,
        value: modality.code,
      })),
    [modalitiesData],
  );
  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__modalities`}
      label="Modalities"
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__modalities-select`}
        isSingleSelect={false}
        onChange={(options) => {
          const selectedValues = Array.isArray(options)
            ? options.map((opt) => opt.value)
            : [];

          onChange(selectedValues);
        }}
        leftIcon={leftIcon}
        options={modalitiesOptions}
        placeholder={placeholder}
        isReadOnly={isReadOnly}
        value={modalitiesOptions?.filter((option) =>
          value?.includes(option.value),
        )}
        withCheckBox
        {...(isReadOnly ? { inputValue: value?.join(', ') } : {})}
      />
    </InputGroupV2>
  );
};
